import React, { useState, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { apiHelpers, endpoints } from '../../services/api';
import LoadingSpinner from '../UI/LoadingSpinner';

const UserCheck = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [hasUsers, setHasUsers] = useState(false);
  const [error, setError] = useState(null);
  const location = useLocation();

  useEffect(() => {
    checkUsers();
  }, []);

  const checkUsers = async () => {
    try {
      setLoading(true);
      setError(null);

      const response = await apiHelpers.get(endpoints.auth.checkUsers);

      console.log('🔍 UserCheck response:', response);

      if (response.success && response.data?.data) {
        setHasUsers(response.data.data.hasUsers);
        console.log('👥 Has users:', response.data.data.hasUsers);
      } else {
        console.error('❌ Failed to check users:', response);
        setError('Failed to check users');
      }
    } catch (error) {
      console.error('Error checking users:', error);
      setError('Failed to check users');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <LoadingSpinner />
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h2 className="text-xl font-semibold text-red-600 mb-2">Error</h2>
          <p className="text-gray-600">{error}</p>
          <button 
            onClick={checkUsers}
            className="mt-4 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
          >
            Retry
          </button>
        </div>
      </div>
    );
  }

  // If no users exist, redirect to first user setup
  if (!hasUsers) {
    console.log('🚀 No users found, redirecting to first user setup');
    // Only redirect if we're not already on the first-user-setup page
    if (location.pathname !== '/first-user-setup') {
      return <Navigate to="/first-user-setup" replace />;
    }
  }

  // If users exist and we're on first-user-setup page, redirect to login
  if (hasUsers && location.pathname === '/first-user-setup') {
    console.log('👥 Users exist but on setup page, redirecting to login');
    return <Navigate to="/login" replace />;
  }

  // If users exist, render children (normal app)
  console.log('👥 Users exist, rendering normal app');
  return children;
};

export default UserCheck;
